import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "test-commands"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Créer une facture ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Erreur lors de la création de la facture")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Créer facture")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InvoiceForm = _resolveComponent("InvoiceForm")!
  const _component_JbAlert = _resolveComponent("JbAlert")!
  const _component_JbButton = _resolveComponent("JbButton")!
  const _component_JbModal = _resolveComponent("JbModal")!

  return (_openBlock(), _createBlock(_component_JbModal, {
    name: "invoice-create",
    cancellable: ""
  }, {
    headerLeft: _withCtx(() => [
      (_ctx.$AppTesting)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.fillForm && _ctx.fillForm(...args)), ["stop"]))
            }, "Fill Form")
          ]))
        : _createCommentVNode("", true),
      _hoisted_2
    ]),
    default: _withCtx(() => [
      _createVNode(_component_InvoiceForm, {
        ref: "invoiceFormRef",
        display: "create",
        type: "admin"
      }, null, 512)
    ]),
    footerLeft: _withCtx(() => [
      (_ctx.createStatus.error)
        ? (_openBlock(), _createBlock(_component_JbAlert, {
            key: 0,
            type: "error"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    footerRight: _withCtx(() => [
      _createVNode(_component_JbButton, {
        bg: "bg-sky-500 hover:bg-sky-400",
        text: "text-white",
        onClick: _ctx.submit_modal
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }))
}